import { ForcedFeatures, OptimizelyClient } from "../types";

const getForcedFeatures = (
  optimizelyClient: OptimizelyClient,
  queryParams: URLSearchParams,
): ForcedFeatures => {
  const config = optimizelyClient.getOptimizelyConfig() ?? {
    featuresMap: {},
  };
  const featuresMap = config.featuresMap;
  const featureIds = Object.keys(featuresMap);
  const forcedFeatures = featureIds
    .filter((featureId) => queryParams.has(featureId))
    .map((featureId) => ({
      featureId,
      variation: queryParams.get(featureId) ?? "",
    }));

  return forcedFeatures;
};

export default getForcedFeatures;
